import React from 'react';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { MultiSelectFieldType } from '@/type';
import MultiSelectInput from '@components/common/input/MultiSelectInput';

interface MultiSelectControllerProps<TFieldValues extends FieldValues = FieldValues> {
  control: Control<TFieldValues>;
  multiSelectField: MultiSelectFieldType;
}

const MultiSelectController = <TFieldValues extends FieldValues = FieldValues>({
  control,
  multiSelectField,
}: MultiSelectControllerProps<TFieldValues>) => {
  return (
    <Controller
      name={multiSelectField.name as any}
      control={control}
      render={({ field, fieldState }) => (
        <MultiSelectInput
          field={field}
          multiSelectField={multiSelectField}
          error={fieldState.error}
        />
      )}
    />
  );
};

export default MultiSelectController;
